var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_bg_cover page_shadow"})
}
var staticRenderFns = []

export { render, staticRenderFns }